interface TextHelperProps {
  isClaimActive: boolean;
}

export const getHeaderText = ({ isClaimActive }: TextHelperProps): string => {
  if (isClaimActive) {
    return 'CONNECT CLAIM WALLET';
  }

  return 'REGISTER AIRDROP WALLET';
};

export const getDescriptionText = ({
  isClaimActive,
}: TextHelperProps): string => {
  if (isClaimActive) {
    return `Connect the Solana wallet where you'd like to receive your $DOOD. Be sure to have at least .01 SOL available in this wallet.`;
  }

  return `Connect the Solana wallet where you'd like to receive your airdrop.`;
};

interface ButtonTextProps {
  isClaimActive: boolean;
  updatingMetadata: boolean;
}

export const getButtonText = ({
  isClaimActive,
  updatingMetadata,
}: ButtonTextProps): string => {
  if (isClaimActive) {
    return updatingMetadata ? 'CLAIMING...' : 'BEGIN CLAIM';
  }

  return 'SAVE REGISTRATION';
};
